import { Breadcrumb } from "antd";
import { cn } from "../../lib/utils";
import { Link } from "react-router-dom";

export default function PageHeader(props) {
    return <div className={cn("bg-white w-full py-[24px] pl-[12px] pr-[16px] flex flex-col justify-between",
        !props.children ? " h-[106px]" : "h-[196px]"
    )} >
        <Breadcrumb items={[
            { title: <Link to={props.route || "/"}>{props.home || "App"}</Link> },
            { title: props.title, }
        ]} />
        <h4 className="font-medium text-xl pt-4">{props.title}</h4>
        {props.children && <div>{props.children}</div>}
    </div>
}